import React from "react";
import MaterialTable from '@material-table/core';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

function SmscConnections(props) {
  const rows = props.data.map(row => {
    return {
      id: row.smscId,
      received: `${row.sms.received} / ${row.dlr.received}`,
      sent: `${row.sms.sent} / ${row.dlr.sent}`,
      ...row
    };
  });

  return (
    <MaterialTable
      title={
        <Typography component="span" color="textSecondary" gutterBottom>
          <Typography component="span" variant="h5">
            SMSC connections
          </Typography>
        </Typography>
      }
      data={rows}
      columns={[
        { title: "Smsc id", field: "smscId", defaultGroupOrder: 0 },
        { title: "Connection", field: "name" },
        { title: "Status", field: "status" },
        { title: "Received sms/dlr", field: "received", type: "numeric" },
        { title: "Sent sms/dlr", field: "sent", type: "numeric" },
        { title: "Failed", field: "failed", type: "numeric" },
        { title: "Queued", field: "queued", type: "numeric" }
      ]}
      options={{
        grouping: true,
        showGroupingCount: true,
        selection: false,
        pageSizeOptions: [10, 50],
        pageSize: 10
      }}
      components={{
        Container: props => <Paper elevation={0} {...props} />
      }}
    />
  );
}

export default SmscConnections;
